import axios from 'axios';
import { RefreshAccessTokenAction, SignOutAction } from '../store/action/authAction';
import { store } from '../store';
import { refreshAccessToken } from '../api/post/Auth';

const retryExcludeUrls = ['/api/v1/auth/token/refresh'];

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT
});

instance.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';

instance.interceptors.request.use((config) => {
    const token = store.getState().accountReducer.accessToken;
    config.headers.Authorization = 'Bearer ' + token;

    return config;
});

instance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        // const originalRequest = error.config;

        // Check if error is 401 and we haven't tried to refresh the token yet
        if (error.response && error.response.status === 401 && !retryExcludeUrls.includes(error.config.url)) {
            store.dispatch(SignOutAction());
            return Promise.reject();
            // try {
            //     // Get refresh token from store
            //     const refreshToken = store.getState().accountReducer.refreshToken;
            //
            //     if (!refreshToken) {
            //         // No refresh token available, sign out
            //         return Promise.reject(error);
            //     }
            //
            //     // Get new access token
            //     const response = await refreshAccessToken(refreshToken);
            //
            //     if (response && response.data.access_token) {
            //         // Update store with new access token
            //         store.dispatch(RefreshAccessTokenAction(response.data.access_token));
            //
            //         // Update Authorization header for the original request
            //         originalRequest.headers.Authorization = 'Bearer ' + response.data.access_token;
            //
            //         // Retry the original request with new token
            //         return instance(originalRequest);
            //     } else {
            //         // Invalid response, sign out
            //         store.dispatch(SignOutAction());
            //         return Promise.reject();
            //     }
            // } catch (refreshError) {
            //     // Token refresh failed, sign out
            //     store.dispatch(SignOutAction());
            //     return Promise.reject();
            // }
        } else {
            return Promise.reject(error);
        }
    }
);

export default instance;
